import React, { useState, useEffect, useRef } from "react";
import { object, func } from "prop-types";
import { Button } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { Map, fromJS } from "immutable";
import helpIcon from "resources/images/circle-help-icon-white.svg";
import criteriaLogo from "resources/images/CriteriaLogo.png";
import HelpCenterSection from "./HelpCenterSection";
import EmailSupportSection from "./EmailSupportSection";
import ContactCSMSection from "./ContactCSMSection";
import SupportBotSection from "./SupportBotSection";

const ContactButton = (props) => {
  const { userData, toggleHelpAssistantModal, featureFlags } = props;
  const [buttonOpacity, setButtonOpacity] = useState("1");
  const [buttonTransform, setButtonTransform] = useState("translateY(0)");
  const [boxOpacity, setBoxOpacity] = useState("0");
  const [boxTransform, setBoxTransform] = useState("translateY(0)");
  const [buttonTimeout, setButtonTimeout] = useState("0s");
  const [boxTimeout, setBoxTimeout] = useState(".3s");
  const [boxBottom, setBoxBottom] = useState("-800px");
  const [height, setHeight] = useState(0);

  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, [ref.current && ref.current.clientHeight]);

  const handleClick = () => {
    setButtonOpacity("0");
    setButtonTransform("translateY(100%)");
    setBoxOpacity("1");
    setBoxTransform("translateY(-100%)");
    setButtonTimeout("0s");
    setBoxTimeout(".3s");
    setBoxBottom(`calc(-${height}px + 16px)`);
  };

  const handleCloseBox = () => {
    setButtonOpacity("1");
    setButtonTransform("translateY(0)");
    setBoxOpacity("0");
    setBoxTransform("translateY(0)");
    setButtonTimeout(".3s");
    setBoxTimeout("0s");
    setBoxBottom("-800px");
  };

  const isInsightUser = userData && userData.partnerAccountId === 47;
  const subscriber = userData && userData.status === "subscriber";
  const suspended = userData && userData.suspended;

  // in case the account is either an AU or US account, but has the `locale` value set to the
  // opposite, we need to determine which default phone number to show based on the subdomain.
  const hostnameArray = window.location.hostname.split(".");
  const subdomain = hostnameArray[0];

  const isAU = (userData && userData.locale === "AU") || subdomain === "app-au";

  // if the rep has been set as default (no CSM rep assigned), then we hide the ContactCSMSection
  const isDefaultRep =
    subscriber || suspended
      ? userData.rep.csm && userData.rep.csm.isDefaultRep
      : userData.rep.sdr && userData.rep.sdr.isDefaultRep;

  // style variables
  const buttonStyle = {
    backgroundColor: "#425CC7",
    color: "#FFF",
    position: "fixed",
    bottom: "16px",
    right: "16px",
    height: "48px",
    width: "48px",
    borderRadius: "50%",
    fontFamily: "Lato",
    fontSize: "13px",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.15)",
    border: "none",
    opacity: buttonOpacity,
    transform: buttonTransform,
    transition: `all .2s ease ${buttonTimeout}`,
    transitionProperty: "opacity, transform",
    zIndex: "1000",
  };

  const boxStyle = {
    position: "fixed",
    right: "16px",
    bottom: boxBottom,
    width: isAU ? "375px" : "350px",
    opacity: boxOpacity,
    transform: boxTransform,
    transition: `all .2s ease ${boxTimeout}`,
    transitionProperty: "opacity, transform",
    zIndex: "999",
    borderRadius: "4px",
    backgroundColor: "#FFF",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.15)",
  };

  const flags =
    featureFlags && Map.isMap(featureFlags)
      ? featureFlags
      : fromJS(featureFlags);

  return (
    <div>
      <Button style={buttonStyle} onClick={handleClick} id="hereToHelp">
        <img src={helpIcon} alt="help" />
      </Button>
      <div ref={ref} style={boxStyle}>
        <Button
          onClick={handleCloseBox}
          className="contact-button-box-header d-flex justify-content-between align-items-center"
          id="contactUs"
        >
          <span>
            <img src={criteriaLogo} alt="Criteria" height="20px" width="77px" />
          </span>
          <div
            style={{
              border: "none",
            }}
            id="expandContactUs"
          >
            <FontAwesome name="chevron-down" style={{ color: "#FFF" }} />
          </div>
        </Button>
        <div className="p-3">
          {!isInsightUser && (subscriber || suspended) ? (
            <>
              {flags.get("isAISupportAssistantEnabled") ? (
                <>
                  <SupportBotSection
                    toggleHelpAssistantModal={toggleHelpAssistantModal}
                  />
                  <hr />
                </>
              ) : null}
              <HelpCenterSection isAU={isAU} />
              <hr />
              <EmailSupportSection isAU={isAU} />
            </>
          ) : null}
          {subscriber ? <hr /> : null}
          <ContactCSMSection
            isInsightUser={isInsightUser}
            isAU={isAU}
            userData={userData}
          />
        </div>
      </div>
    </div>
  );
};

ContactButton.propTypes = {
  userData: object,
  toggleHelpAssistantModal: func,
  featureFlags: object,
};

export default ContactButton;
